import React, { useState, useEffect } from 'react';
import DataGrid from '../../../../../components/DataGrid/DataGrid';
import { localText } from '../../../../../langs/fa/data-grid';
import { store } from './reducer';
import moment from 'moment-jalaali';
import { formatNumber } from 'fns';
import { useHistory } from 'react-router-dom';
import UsersDialog from '../../../../../components/Dialog/UsersDialog/UsersDialog';
import { useCalculation } from 'useStores/useCalculation';
import { useMainStore } from 'useStores/useMainStore';

const List = () => {
  const history = useHistory();
  const [customer, setCustomer] = useState(null);
  const [customerDialog, setCustomerDialog] = useState(false);
  const [orderSelected, setOrderSelected] = useState(null);

  const itemsCountPerPage = useMainStore((state) => state.limit);
  const calcOrders = useCalculation((state) => state.basePrice.orders);
  const progress = useCalculation((state) => state.filters.progress);
  const { averagePrice, basePriceAverage, totalAverage, orders } = calcOrders;
  const page = useCalculation((state) => state.basePrice.pages);
  const changePage = useCalculation((state) => state.changePage);

  const columns = [
    {
      field: 'operator',
      headerName: 'اپراتور',
      width: 100,
      renderCell: ({ value: { operator } }) =>
        `${operator.firstName} ${operator.lastName}`,
    },
    {
      field: 'loadingDate',
      headerName: 'تاریخ',
      width: 100,
      renderCell: ({ value }) => moment(value.loadDate).format('jYY/jMM/jDD'),
    },
    {
      field: 'origin',
      headerName: 'مبدا',
      width: 100,
      renderCell: ({ value: { origin } }) => origin.title,
    },
    {
      field: 'fleetOptions',
      headerName: 'نوع ناوگان',
      flex: 1,
      renderCell: ({ value: { fleetOptions } }) =>
        fleetOptions.map((f) => `${f.fleet.title}(${f.title})`).join('، '),
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
      renderCell: ({ value: { destination } }) => destination.title,
    },
    {
      field: 'loadType',
      headerName: 'نوع محموله',
      width: 150,
      renderCell: ({ value: { cargos } }) => cargos[0].type.title,
    },
    {
      field: 'basePrice',
      headerName: 'کرایه حمل',
      flex: 1,
      renderCell: ({ value: { basePrice } }) => formatNumber(basePrice),
    },
  ];

  // const handleSelectOrder = ({ row, field }) => {
  //   const _order = orders?.docs?.find((order) => order._id === row.id);
  //   const order = {
  //     cargos: [setCustomerDialog
  //       {
  //         type: _order?.cargos?.[0]?.type,
  //       },
  //     ],
  //     destination: _order?.destination,
  //     basePrice: _order?.basePrice,
  //     fleetOptions: _order?.fleetOptions,
  //   };
  //   setOrderSelected(order);
  //   (true);
  // };
  const handleSelectRow = (selection) => {
    history.push(`/protected/admin/orders/${selection.row.id}`);
  };
  const handlePageChange = (page) => {
    changePage(page);
  };
  const handleSelectCustomer = (customer) => {
    customer?.[0] && setCustomer(customer[0]);
  };
  const handleCloseCustomerDialog = () => {
    setCustomerDialog(false);
    // setOrderSelected(null);
  };

  const handleAverageClicked = () => {
    const order = {
      basePrice: averagePrice * 1,
    };
    setOrderSelected(order);
    setCustomerDialog(true);
  };
  const handleBasePriceAverageClicked = () => {
    const order = {
      basePrice: basePriceAverage * 1,
    };
    setOrderSelected(order);
    setCustomerDialog(true);
  };
  const handleTotalAverageClicked = () => {
    const order = {
      basePrice: totalAverage * 1,
    };
    setOrderSelected(order);
    setCustomerDialog(true);
  };

  useEffect(() => {
    if (orderSelected && customer && !customerDialog) {
      history.push(`/protected/admin/orders/add`, {
        order: { ...orderSelected, customer },
      });
    }
  }, [orderSelected, customer, customerDialog]);

  return (
    <div style={{ height: 300, position: 'relative' }}>
      {/* <UsersDialog
        single
        open={customerDialog}
        onChange={handleSelectCustomer}
        closeDialog={handleCloseCustomerDialog}
        role={['customer']}
      /> */}
      <DataGrid
        rows={
          orders?.docs?.map
            ? orders.docs.map((order) => ({
                id: order._id,
                operator: order,
                loadingDate: order,
                origin: order,
                fleetOptions: order,
                destination: order,
                loadType: order,
                basePrice: order,
              }))
            : []
        }
        columns={columns}
        localeText={localText}
        pageSize={itemsCountPerPage}
        rowCount={orders?.totalDocs || 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={progress}
        disableMultipleSelection
        // onCellClick={handleSelectOrder}
        density="compact"
        onCellClick={handleSelectRow}
      />
      <div
        style={{
          position: 'absolute',
          bottom: 15,
          right: 15,
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gridGap: 10,
        }}
      >
        <div
          style={{
            fontSize: 20,
            padding: '5px 15px',
            border: '1px solid #673ab7',
            background: '#b39ddb',
            cursor: averagePrice ? 'pointer' : 'default',
          }}
          onClick={averagePrice ? handleAverageClicked : null}
        >
          میانگین سیستم: <strong>{formatNumber(averagePrice || 0)}</strong>{' '}
          تومان
        </div>
        {/* <div
          style={{
            fontSize: 20,
            padding: '5px 15px',
            border: '1px solid #ef5350',
            background: '#ef9a9a',
            cursor: basePriceAverage ? 'pointer' : 'default',
          }}
          onClick={basePriceAverage ? handleBasePriceAverageClicked : null}
        >
          میانگین عرفی: <strong>{formatNumber(basePriceAverage || 0)}</strong>{' '}
          تومان
        </div> */}
        {/* <div
          style={{
            fontSize: 20,
            padding: '5px 15px',
            border: '1px solid #1b5e20',
            background: '#a5d6a7',
            cursor: totalAverage ? 'pointer' : 'default',
          }}
          onClick={totalAverage ? handleTotalAverageClicked : null}
        >
          میانگین کل: <strong>{formatNumber(totalAverage || 0)}</strong> تومان
        </div> */}
      </div>
    </div>
  );
};

export default React.memo(List);
